// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__0xaVg","medium":"styles_medium__rK4ox","large":"styles_large__oBE6F","disabled":"styles_disabled__V5kZk"};